import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../shared/services/http-client/http-client.service';
import {
  RequerimentoOnlineResponseDto,
  SalvarRequerimentoOnlineCommandDto,
} from '../../models/parametros/requerimento-online-api.model';

const PLANOS_PARAM_BASE_PATH = '/v1/planos-param';

@Injectable({
  providedIn: 'root',
})
export class RequerimentoOnlineApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  /** Uma configuração por tipo de requerimento ativo (`id` nulo = tipo ainda sem configuração no plano). */
  listarConfiguracoes(idPlano: number): Observable<RequerimentoOnlineResponseDto[]> {
    return this.httpClient.get<RequerimentoOnlineResponseDto[]>(this.requerimentoPath(idPlano));
  }

  /** Cria ou substitui a configuração do tipo no plano; devolve o agregado gravado. */
  salvarConfiguracao(
    idPlano: number,
    idTpReqr: number,
    command: SalvarRequerimentoOnlineCommandDto,
  ): Observable<RequerimentoOnlineResponseDto> {
    return this.httpClient.put<RequerimentoOnlineResponseDto>(`${this.requerimentoPath(idPlano)}/${idTpReqr}`, command);
  }

  private requerimentoPath(idPlano: number): string {
    return `${PLANOS_PARAM_BASE_PATH}/${idPlano}/requerimento-online`;
  }
}
